































































import TopHeader from '@/views/templates/TopHeader.vue'
import TopAnimation from '@/views/templates/TopAnimation.vue'
import TopFirstPage from '@/views/page/TopFirstPage.vue'
import TopSecondPage from '@/views/page/TopSecondPage.vue'
import TopThirdPage from '@/views/page/TopThirdPage.vue'
import TopStorePage from '@/views/page/TopStorePage.vue'
import Footer from '@/views/templates/Footer.vue'
export default
  name: 'TopPage'

  components: {
    TopAnimation
    TopHeader
    TopFirstPage
    TopSecondPage
    TopThirdPage
    TopStorePage
    Footer
  }

  data: () ->
    show_mizunasu_message: false
    show_tenugui_message: false
    show_afurika_message: false
    show_kuntama_message: false
    init_whiteout: false
    execute_whiteout: false
    show_animation: true

  created: () ->
    if @$cookies.isKey('IsStarted')
      @show_animation = false
    @$cookies.set('IsStarted', 1, 0)

  methods: {
    change_mizunasu_message: (e) ->
      @show_mizunasu_message = !@show_mizunasu_message
    change_tenugui_message: (e) ->
      @show_tenugui_message = !@show_tenugui_message
    change_afurika_message: (e) ->
      @show_afurika_message = !@show_afurika_message
    change_kuntama_message: (e) ->
      @show_kuntama_message = !@show_kuntama_message
    whiteout: (e) ->
      @init_whiteout = true
      setTimeout(() =>
        @execute_whiteout = true
      , 100)
      setTimeout(() =>
        @execute_whiteout = false
        @show_animation = false
      , 2800)
      setTimeout(() =>
        @init_whiteout = false
      , 5200)
  }

